import request from '@/utils/request'
import Qs from 'qs'

export function newsDetail (data) {
  // 获取一级商品列表
  return request({
    url: '/news/webNewsDetail.action',
    method: 'post',
    transformRequest: [function (data) { // 对 data 进行任意转换处理
      return Qs.stringify(data)
    }],
    data: data
  })
}

export function newsList () {
  // 获取一级商品列表
  return request({
    url: '/news/webNewsList.action',
    method: 'post'
  })
}

export function newsMainList () {
  // 获取首页展示新闻
  return request({
    url: '/news/webHomeNewsList.action',
    method: 'post',
  })
}
